import { RootState } from "../global/Store";
import { Season } from "./seasonReducer";

export const selectSeasons = (state: RootState) => state.seasons.data;
export const selectActiveSeasons = (state: RootState) =>
  state.seasons?.data?.filter((s: Season) => s.active);
export const selectSeason = (state: RootState, seasonName: string) =>
  state.seasons?.data?.find((season) => season.name === seasonName);
